module.exports = __webpack_public_path__ + "static/media/19ESCAP33.27a3d1c9.jpg";